export default {"src":"/_next/static/media/purpleIcon.07b86989.svg","height":22,"width":22};